import { Component, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { FooterResponse } from '@digital-platform/rs-cms/domain';
import { CmsFooterService } from '@digital-platform/rs-cms/services';
import { EmailValidationService } from '../preference-center/email-validation.service';
import { PreferenceCenterService } from '../preference-center/preference-center.service';

@Component({
  selector: 'digital-platform-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  private cmsFooterService = inject(CmsFooterService);
  public pageContent$: Observable<FooterResponse> =
    this.cmsFooterService.footerContent$;
  communicationMethodResponse: any;
  emailValue = '';

  constructor(
    private emailValidationService: EmailValidationService,
    private preferenceCenterService: PreferenceCenterService
  ) {
    this.pageContent$.subscribe(() => {});
    this.cmsFooterService.emailInput$.subscribe((res) => {
      this.emailValue = res;
      this.validateEmail(res);
    });
  }

  getCmsCommunicationDetails() {
    this.preferenceCenterService
      .getCmsCommunicationDetails()
      .subscribe((res: any) => {
        if (res?.statusCode === 200) this.communicationMethodResponse = res;
        this.getCommunicationMethods();
      });
  }

  getCommunicationMethods() {
    this.preferenceCenterService
      .getCommunicationMethods(false)
      .subscribe((res: any) => {
        if (res?.statusCode === 200) {
        }
        this.createPreferenceProfile();
      });
  }

  createPreferenceProfile() {
    const body = {
      checkIfExists: true,
      emails: [{ emailAddress: this.emailValue, type: 'Primary' }],
      isGlobalOptOut: false,
      preferences: [
        {
          communicationMethods: [
            {
              communicationMethod: 'Email',
              communicationMethodId: '2',
              isCommunicationAllowed: true,
            },
          ],
          preference: 'Service Alerts and Updates',
          preferenceTypeId: '11',
        },
        {
          communicationMethods: [
            {
              communicationMethod: 'Email',
              communicationMethodId: '2',
              isCommunicationAllowed: true,
            },
          ],
          preference: 'Regular Service Updates',
          preferenceTypeId: '12',
        },
      ],
      userRole: 'Guest',
    };
    this.preferenceCenterService
      .createPreferenceProfile(body)
      .subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.cmsFooterService.emailInputSuccess$.next(res.data);
        }
      });
  }

  validateEmail(email: string) {
    this.emailValidationService.validate(email).subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.emailValue = email;
        this.getCmsCommunicationDetails();
      }
    });
  }
}
